import { getDefaultPanelColors } from './get-default-panel-colors';

export function setDefaultPanelTextHover(themeWrapper: HTMLBodyElement): void {
  themeWrapper.style.setProperty('--panelTextHover', getDefaultPanelColors().panelTextHover);
}
